import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";

export default function GeometricSequencePreparationTheory() {
  const intro = (
    <div className="space-y-3">
      <p>
        W ciągu geometrycznym każdy kolejny wyraz otrzymujemy przez pomnożenie
        poprzedniego przez stały iloraz <InlineMath math="q" />.
      </p>
      <BlockMath math={String.raw`a_{n+1}=a_nq\qquad q=\frac{a_{n+1}}{a_n}`} />
      <p>Znając pierwszy wyraz i iloraz, obliczamy dowolny wyraz ze wzoru:</p>
      <BlockMath math="a_n=a_1q^{n-1}" />
      <p>Dla <InlineMath math={String.raw`q\ne1`} /> suma pierwszych <InlineMath math="n" /> wyrazów wynosi:</p>
      <BlockMath math={String.raw`S_n=a_1\frac{1-q^n}{1-q}`} />
      <p>Dla trzech kolejnych wyrazów kwadrat środkowego jest iloczynem sąsiednich:</p>
      <BlockMath math={String.raw`a_n^2=a_{n-1}\cdot a_{n+1}`} />
      <p>
        Samo równanie kwadratowe może dać dwie liczby przeciwne. Jeżeli jednak w treści
        podano, że ciąg jest dodatni, wybieramy wyłącznie dodatni pierwiastek.
      </p>
    </div>
  );

  const examples = [
    {
      label: "Przykład 1",
      summary: "Obliczanie piątego wyrazu ciągu geometrycznego",
      description: "Z danych a₁ = 3 i q = 2 obliczamy konkretnie wyraz a₅.",
      content: <BlockMath math={String.raw`a_1=3,\ q=2\quad\Longrightarrow\quad a_5=3\cdot2^4=48`} />,
    },
    {
      label: "Przykład 2",
      summary: "Obliczanie ilorazu na podstawie wyrazów a₃ i a₄",
      description: "Dzielimy wyraz a₄ przez poprzedzający go wyraz a₃.",
      content: <BlockMath math={String.raw`a_3=-6,\ a_4=18\quad\Longrightarrow\quad q=\frac{18}{-6}=-3`} />,
    },
    {
      label: "Przykład 3",
      summary: "Obliczanie sumy czterech początkowych wyrazów",
      description: "Z danych a₁ = 2 i q = 3 obliczamy konkretnie sumę S₄.",
      content: <BlockMath math={String.raw`a_1=2,\ q=3\quad\Longrightarrow\quad S_4=2\cdot\frac{1-3^4}{1-3}=80`} />,
    },
  ];

  return <TheoryExamplesRunner intro={intro} examples={examples} />;
}
